/**
 * State name
 */
export const TAGS = 'TAGS';
